module.exports = __webpack_public_path__ + "img/iconbiology.4badefe9.png";